import { useEffect, useState } from "react";
import api from "@/lib/api";
import AlbumCard from "@/components/AlbumCard";
import TrackRow from "@/components/TrackRow";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Browse() {
  const [albums, setAlbums] = useState([]);
  const [tracks, setTracks] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/albums").then((r) => setAlbums(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/tracks${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setTracks(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const filteredAlbums = q
    ? albums.filter((a) => (a.title + a.artist).toLowerCase().includes(q.toLowerCase()))
    : albums;

  return (
    <div className="px-6 md:px-12 py-10">
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-6">BROWSE</h1>
      <div className="relative mb-10 max-w-xl">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input
          data-testid="search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search tracks & artists..."
          className="pl-10 h-12 bg-transparent border-2 border-border focus:border-primary rounded-none text-white"
        />
      </div>

      {filteredAlbums.length > 0 && (
        <>
          <h2 className="font-display text-lg font-bold overline tracking-widest mb-4">Albums</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-12">
            {filteredAlbums.map((a) => <AlbumCard key={a.id} album={a} />)}
          </div>
        </>
      )}

      <h2 className="font-display text-lg font-bold overline tracking-widest mb-4">All Tracks</h2>
      {tracks.length === 0 ? (
        <div className="border-2 border-dashed border-border p-12 text-center text-muted-foreground text-sm">No tracks found.</div>
      ) : (
        <div className="border-t border-border">
          {tracks.map((t, i) => <TrackRow key={t.id} track={t} index={i} list={tracks} />)}
        </div>
      )}
    </div>
  );
}
